import { render, staticRenderFns } from "./AlbumSettings.vue?vue&type=template&id=776270e2"
import script from "./AlbumSettings.vue?vue&type=script&lang=js"
export * from "./AlbumSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports